/**
 * iOS Safari / standalone モード判定ユーティリティ。
 *
 * iOS Safari 判定は UA 文字列を引数に取り、テスト容易性を確保する。
 * iOS Chrome (CriOS) / Firefox (FxiOS) / Edge (EdgiOS) は除外。
 */

export function isIosSafari(ua: string): boolean {
  const isIos = /iPad|iPhone|iPod/.test(ua);
  const isWebkit = /WebKit/.test(ua);
  const isNotOtherBrowser = !/CriOS|FxiOS|EdgiOS/.test(ua);
  return isIos && isWebkit && isNotOtherBrowser;
}

export function isStandalone(): boolean {
  try {
    if ((navigator as { standalone?: boolean }).standalone === true) return true;
    if (typeof window.matchMedia === 'function'
        && window.matchMedia('(display-mode: standalone)').matches) {
      return true;
    }
    return false;
  } catch {
    return false;
  }
}
